const imageMap = {
  carousel_banner_1: require('../../assets/images/mm_opt_in_out_carousel_banner_1.png'),
  carousel_banner_2: require('../../assets/images/mm_opt_in_out_carousel_banner_2.png'),
  carousel_banner_3: require('../../assets/images/mm_opt_in_out_carousel_banner_3.png'),
  welcome_new_user_modal_banner: require('../../assets/images/mm_welcome_new_user_modal_banner.png'),
  welcome_new_user_modal_badge: require('../../assets/images/mm_welcome_new_user_modal_badge.png'),
  opt_out_screen_image: require('../../assets/icons/login-page-icons/doctory.png'),
} as const;

export type ImageKey = keyof typeof imageMap;
export default imageMap;
